"use strict";

var BmpFilter = function () {
  const searchFields = ["bmpName", "address"];

  var filterResourceDataHandler = function (unfilteredData, filters, loadingScreen, smartFilters) {
    const filteredData = ResourceFilters.spatialFilters(unfilteredData, filters);
    if (smartFilters) {
      return smartFilters.filter(filteredData, filters);
    } else {
      return filteredData;
    }
  };

  var passScoreFilter = function (datum, filters) {
    return OfflineFilterFunctions.passMinMaxFilter(datum.score, filters.score);
  };

  var passDateFilter = function (dateData, filters, dateType) {
    return ResourceFilters.passIsoDateFilter(
      dateData,
      filters[dateType]?.from,
      filters[dateType]?.to,
    );
  };

  var getFilterConfigs = function () {
    return {
      drainsToRw: "drains_to_rw",
      drainsToC: "drains_to_c",
      catchmentName: "catchment_name",
      phase: "phase",
      types: "bmp_kind",
      ownership: "landOwnership",
      subGroups: "groupId",
      otherFilters: (datum, filters) => {
        return (
          ResourceFilters.passSearchStringFilter(datum, filters, searchFields) &&
          passScoreFilter(datum, filters) &&
          passDateFilter(datum.bmp_creation, filters, "installDate") &&
          passDateFilter(datum.fcs_obs_date, filters, "assessmentDate")
        );
      },
    };
  };

  return {
    filterResourceDataHandler,
    getFilterConfigs,
  };
};

module.exports = BmpFilter();

const OfflineFilterFunctions = require("../mapFunctions/offlineFilterFunctions");
const ResourceFilters = require("./resourceFilters");
